import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [employees, setEmployees] = useState([]);
  const [settings, setSettings] = useState(null);
  const [currentUser, setCurrentUser] = useState(() => {
    const saved = localStorage.getItem("currentUser");
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(true);

  const refreshEmployees = useCallback(async () => {
    const e = await api.listEmployees(true);
    setEmployees(e);
    return e;
  }, []);

  const refreshSettings = useCallback(async () => {
    const s = await api.getSettings();
    setSettings(s);
    return s;
  }, []);

  useEffect(() => {
    Promise.all([refreshEmployees(), refreshSettings()]).finally(() => setLoading(false));
  }, [refreshEmployees, refreshSettings]);

  const selectUser = (emp) => {
    setCurrentUser(emp);
    localStorage.setItem("currentUser", JSON.stringify(emp));
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem("currentUser");
  };

  const activeEmployees = employees.filter((e) => e.active);
  const telecallers = activeEmployees.filter((e) => e.role === "telecaller");

  return (
    <AppContext.Provider
      value={{
        employees, activeEmployees, telecallers, settings, currentUser, loading,
        refreshEmployees, refreshSettings, selectUser, logout, setSettings,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
